import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconMapsS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3 6L1 9L1.96774 13.3333L5.16667 15L9.33333 13.75L11 10.8333L10.0323 6.66667L6.80645 5L3 6Z"
        fill="#FFA10A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.0691 9.19912L2.84232 12.6614L5.26844 13.9254L8.66331 12.907L9.93722 10.6776L9.16272 7.34299L6.68885 6.06483L3.62139 6.87069L2.0691 9.19912ZM3 6L1 9L1.96774 13.3333L5.16667 15L9.33333 13.75L11 10.8333L10.0323 6.66667L6.80645 5L3 6Z"
        fill="var(--color-typo-primary)"
      />
      <path d="M6 2L4 5.5L5 10L8.5 12L13.5 10.5L15 7.5L14 3L10.5 1L6 2Z" fill="#FFA10A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 12L5.75507 10.4315L5.72358 10.4472L5.69996 10.4L5 10L4 5.5L6 2L10.5 1L14 3L15 7.5L13.5 10.5L8.5 12ZM5.18376 6.21713L5.86015 9.2609L8.31793 8.032L11.9299 7H13.8645L13.1978 4L11.07 4L7.68202 4.968L5.18376 6.21713ZM5.45968 4.96113L7.31793 4.032L10.9299 3H11.9844L10.3395 2.06005L6.64877 2.88022L5.45968 4.96113ZM8.68202 8.968L6.83004 9.89398L8.62361 10.9189L12.7988 9.66633L13.632 8H12.07L8.68202 8.968Z"
        fill="var(--color-typo-primary)"
      />
    </svg>
  )
}

export const IconMaps = createIcon({
  l: IconMapsS,
  m: IconMapsS,
  s: IconMapsS,
  xs: IconMapsS,
  name: 'IconMaps',
})
